export default class ApplicationMemberFile {
    static fromData(data) {
        if (!data) {
            return;
        }

        let file = new ApplicationMemberFile();
        file.id = data.id;
        file.hash = data.hash;
        file.title = data.title;
        file.downloadUrl = data.downloadUrl;
        file.extension = data.extension;
        file.mimeType = data.mimeType;
        file.isImage = data.isImage;
        file.size = data.size;
        file.isMemberFile = data.isMemberFile;

        return file;
    }
}
